import * as React from 'react';
import i18n from '@i18next/i18n';
import {
    Controller,
    Toolbar,
    CustomArgs,
    UIConfig,
    StateManager,
    skipWithDefault,
    SelectList,
    Loader,
    IDynamicLoader,
} from '@tencent/workbench';
import { TOOLBAR_ITEMS, config } from './config';
import { wrapIdForInput, wrapIdForTableTabInput, wrapIdForTextTab } from '@framework/workbench/util/wrap-id-util';
import { IFontFamilyFeature } from './font-family-interface';

/**
 * 工具栏 - 字体
 */
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class FontFamilyController {
    constructor(
        private readonly stateManager: StateManager,
        @Loader(IFontFamilyFeature) private loader: IDynamicLoader<IFontFamilyFeature>,
    ) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Toolbar(config.id, 'style')
    @Toolbar(wrapIdForInput(config.id), 'style')
    @Toolbar(wrapIdForTableTabInput(config.id), 'style')
    @Toolbar(wrapIdForTextTab(config.id), 'style')
    public getStyle(
    @CustomArgs() args: { isInput: string; style: React.CSSProperties },
        @UIConfig() { style }: { style: React.CSSProperties },
    ) {
        const fontStyle: React.CSSProperties = {
            ...style,
        };
        return fontStyle;
    }

    // 给ui绑定对应的计算属性
    @Toolbar(config.id, 'text')
    @Toolbar(wrapIdForInput(config.id), 'text')
    @Toolbar(wrapIdForTableTabInput(config.id), 'text')
    @Toolbar(wrapIdForTextTab(config.id), 'text')
    @skipWithDefault(i18n.t('字体'))
    public getFontName() {
        return this.feature.getFontFamilyName();
    }

    @Toolbar(config.id, 'dropdownContent')
    @Toolbar(wrapIdForInput(config.id), 'dropdownContent')
    @Toolbar(wrapIdForTableTabInput(config.id), 'dropdownContent')
    @Toolbar(wrapIdForTextTab(config.id), 'dropdownContent')
    @skipWithDefault(<SelectList />)
    public renderSelectList(isDrawer?: boolean) {
        return this.feature.renderSelectList(isDrawer);
    }

    @Toolbar(config.id, 'onDropdownVisibleChange')
    @Toolbar(wrapIdForInput(config.id), 'onDropdownVisibleChange')
    @Toolbar(wrapIdForTableTabInput(config.id), 'onDropdownVisibleChange')
    @Toolbar(wrapIdForTextTab(config.id), 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.feature.updateDropdownVisible(visible, config.id);
    }
}
